angular.module('jsPDF').factory('jsPDF', [
  '$q', '$document', '$window',
  function ($q, $document, $window) {
    var loadPromise;

    function getConstructor() {
      return $window.jspdf && $window.jspdf.jsPDF;
    }

    function load() {
      var loaded = getConstructor();
      if (loaded) {
        return $q.resolve(loaded);
      }

      if (loadPromise) {
        return loadPromise;
      }

      var scriptUrl = $window.env && $window.env.jspdf_url;
      if (!scriptUrl) {
        return $q.reject(new Error('jsPDF asset URL is not configured'));
      }

      loadPromise = $q(function (resolve, reject) {
        var script = $document[0].createElement('script');
        script.async = true;
        script.src = scriptUrl;
        script.onload = function () {
          var jsPDF = getConstructor();
          if (!jsPDF) {
            loadPromise = undefined;
            script.remove();
            reject(new Error('Loaded jsPDF asset did not expose window.jspdf.jsPDF'));
            return;
          }
          resolve(jsPDF);
        };
        script.onerror = function () {
          loadPromise = undefined;
          script.remove();
          reject(new Error('Failed to load jsPDF asset: ' + script.src));
        };
        $document[0].head.appendChild(script);
      });

      return loadPromise;
    }

    return { load: load };
  }
]);
